import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCollectionListbyWalletAddress } from '../../hooks/Collectionhook';
import DynamicCollectionCard from './DynamicCardUI/DynamicCollectionCard';
import CollectionCardPlaceholder from '../cards/CollectionCardPlaceholder';
import Pagination from '../Pagination';
import { listNFTs } from '../../hooks/NFTHook';

function UserCollection(props) {
  // State management
  const [collectionList, setCollectionList] = useState([]); // Stores the collection data
  const [hasMore, setHasMore] = useState(true); // Checks if more data is available
  const [currentPage, setCurrentPage] = useState(0); // Current page for pagination
  const [limit, setLimit] = useState(props.length); // Number of items per page
  const [isPagination, setIsPagination] = useState(false); // Controls pagination visibility
  const [pageCount, setPageCount] = useState(0); // Total number of pages
  
  const location = useLocation(); // To get the current route
  const navigate = useNavigate(); // For navigation
  const WalletAddress = localStorage.getItem("WalletAddress"); // Fetch wallet address from localStorage

  // Fetch collections whenever the currentPage changes
  useEffect(() => {
    fetchCollections();
  }, [currentPage]);

  /**
   * Fetch collections based on the wallet address and pagination settings.
   */
  const fetchCollections = async () => {
    const Params = {
      page: currentPage + 1, // Convert zero-based index to one-based
      limit: limit, // Number of items per page
      sortBy: 'createdAt', // Sort by creation date
      ownerAddress: WalletAddress, // Filter by wallet address
    };

    try {
      const data = await getCollectionListbyWalletAddress(Params);
      if (data.success) {
        // Fetch market data for the collections
        const collectionsWithMarketData = await fetchMarketDataForCollections(data.data);
        setCollectionList(collectionsWithMarketData); // Update collection list
        setPageCount(data.totalPages); // Update total page count

        // Show pagination only on specific routes and if there are multiple pages
        if (location.pathname === "/collections" || location.pathname === "/profile") {
          setIsPagination(data.totalPages > 1);
        }

        // Update hasMore flag based on the total data count
        setHasMore(data.total > 0);
      }
    } catch (error) {
      console.error('Error fetching collections:', error);
      setHasMore(false); // No more data available on error
    }
  };

  /**
   * Fetch market data for each collection.
   * @param {Array} collections - List of collections to fetch market data for
   * @returns {Array} - Collections with market data
   */
  const fetchMarketDataForCollections = async (collections) => {
    const marketDataPromises = collections.map(async (collection) => {
      const marketData = await fetchMarketData(collection.contractAddress);
      // Add market data to the collection if available
      return marketData?.total > 0 ? { ...collection, marketData } : null;
    });

    const collectionsWithMarketData = await Promise.all(marketDataPromises);
    return collectionsWithMarketData.filter(Boolean); // Filter out null values
  };

  /**
   * Fetch market data for a specific collection.
   * @param {string} contractAddress - Contract address of the collection
   * @returns {Object} - Market data response
   */
  const fetchMarketData = async (contractAddress) => {
    const params = { page: 1, limit: 4, contractAddress, sortBy: 'createdAt' };
    const marketData = await listNFTs(params);
    return marketData.success ? marketData : { success: false, data: [] };
  };

  /**
   * Handle page change for pagination.
   * @param {Object} selectedItem - Selected page item
   */
  const handlePageChange = (selectedItem) => {
    setCollectionList([]); // Clear the current collection list
    setCurrentPage(selectedItem.selected); // Update the current page
  };

  /**
   * Redirect to the "collections" page with a specific state.
   */
  const handleRedirect = () => {
    navigate("/collections", { state: "user" }); // Navigate to collections page
  };
console.log("User Collection", collectionList);

  return (
    <>
      <div className="row justify-content-center mb-30_reset">
        {/* Header Section */}
        <div
          className="d-flex section__head space-x-20 justify-content-between align-items-center"
        >
          <h2 className="section__title text-center">Your Collections</h2>
          <div onClick={handleRedirect} className="btn btn-sm btn-dark"> View all </div>
        </div>

        {/* Collection Grid */}
        <div className="row">
          {/* If collections exist, render them */}
          {collectionList.length !== 0 ? (
            collectionList.map((val, i) => (
              <div className="col-lg-4 col-md-6 col-sm-12 card-hover-effect" key={i}>
                <DynamicCollectionCard
                  CollectionLink={`/collectionDetails/${val.contractAddress}`}
                  marketItem={val.marketData?.data || []}
                  ownerDetails={val.ownerDetails}
                  collectionName={val.name}
                  collectionLogo={val.logo}
                  owner={false}
                  totalMarketItem={val.marketData?.total || 0}
                />
              </div>
            ))
          ) : (
            // If no collections exist, show placeholders or a message
            hasMore ? (
              [...Array(props.length)].map((_, index) => (
                <div className="col-lg-4 col-sm-12" key={index}>
                  <CollectionCardPlaceholder />
                </div>
              ))
            ) : (
              <h3>No own Collection available</h3>
            )
          )}

          {/* Pagination Section */}
          <div>
            {isPagination && (
              <Pagination
                pageCount={pageCount}
                onPageChange={handlePageChange}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default UserCollection;
